import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

import Hero from "../components/Hero";
import Features from "../components/Features";
import About from "../components/About";
import Contact from "../components/Contact";
import Clients from "../components/Clients";
import Terms from "../components/Terms";
import Privacy from "../components/Privacy";
import pkg from "../../package.json";

const Home = () => {
  const [openSection, setOpenSection] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // 1️⃣ Handle HASH for Terms
    if (location.hash === "#terms") {
      setOpenSection("terms");
      setTimeout(() => {
        document
          .getElementById("terms-section")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return;
    }

    // 2️⃣ Handle HASH for Privacy
    if (location.hash === "#privacy") {
      setOpenSection("privacy");
      setTimeout(() => {
        document
          .getElementById("privacy-section")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return;
    }

    // 3️⃣ Handle normal section scrolling (#features, #about, etc.)
    if (location.hash) {
      setOpenSection(null);
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 50);
      return;
    }

    // 4️⃣ Default: top of page
    setOpenSection(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.hash]);




  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const openTerms = () => {
    setOpenSection("terms");
    setTimeout(() => {
      document.getElementById("terms-section")?.scrollIntoView({
        behavior: "smooth",
      });
    }, 100);
  };

  const openPrivacy = () => {
    setOpenSection("privacy");
    setTimeout(() => {
      document.getElementById("privacy-section")?.scrollIntoView({
        behavior: "smooth",
      });
    }, 100);
  };

  return (
    <div className="home-page">
      {/* MAIN SECTIONS */}
      <section id="home"><Hero /></section>
      <section id="features"><Features /></section>
      <section id="clients"><Clients /></section>
      <section id="about"><About /></section>
      <section id="contact"><Contact /></section>

      {/* COLLAPSIBLE TERMS */}
      {openSection === "terms" && (
        <section id="terms-section">
          <Terms />
        </section>
      )}

      {/* COLLAPSIBLE PRIVACY */}
      {openSection === "privacy" && (
        <section id="privacy-section">
          <Privacy />
        </section>
      )}

      {/* FOOTER */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">

            {/* Logo */}
            <div className="footer-section">
              <div className="footer-logo">
                <img
                  src="/assets/images/feezaap-logo.png"
                  alt="FeeZaap Logo"
                />
                <span>FeeZaap</span>
              </div>
              <p>
                Revolutionizing dance school fee management with secure, digital
                solutions.
              </p>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><NavLink to="/" end>Home</NavLink></li>
                <li><Link to="/#features">Features</Link></li>
                <li><Link to="/#clients">Clients</Link></li>
                <li><Link to="/#about">About</Link></li>
                <li><Link to="/#contact">Contact</Link></li>
                <li><NavLink to="/login">Login</NavLink></li>
              </ul>
            </div>

            {/* Legal (React-only, no routing) */}
            <div className="footer-section">
              <h3>Legal</h3>
              <ul>
                <li>
                  <button
                    type="button"
                    className="footer-link"
                    onClick={() => {
                      scrollToTop();
                      openTerms();
                    }}
                  >
                    Terms & Conditions
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    className="footer-link"
                    onClick={() => {
                      scrollToTop();
                      openPrivacy();
                    }}
                  >
                    Privacy Policy
                  </button>
                </li>

                <li>
                  <a
                    href="https://napeans.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link"
                  >
                    Napeans Technologies
                  </a>
                </li>
              </ul>
            </div>

            {/* Download App */}
            <div className="footer-section">
              <h3>Download App</h3>
              <div className="app-buttons">
                <a
                  href="https://play.google.com/store"
                  className="app-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-google-play"></i>
                  <span>Play Store</span>
                </a>
                <a
                  href="https://apps.apple.com"
                  className="app-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-app-store-ios"></i>
                  <span>App Store</span>
                </a>
              </div>
            </div>

          </div>

          <div className="footer-bottom">
            <p>
              © 2026 FeeZaap by{" "}
              <a
                href="https://napeans.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Napeans Technologies
              </a>
              . All rights reserved.
            </p>
            <p className="footer-version">Version {pkg.version}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
